import { FC } from 'react'
import { User } from '@phosphor-icons/react'

import { IconPropsType } from '~/src/components/generic/PhosphorIcons/types'

const Icon: FC<IconPropsType> = ({
  'aria-label': ariaLabel,
  color,
  size,
  mirrored,
  weight,
}) => (
  <User
    color={color}
    size={size}
    weight={weight}
    mirrored={mirrored}
    aria-label={ariaLabel}
  />
)

export default Icon
